import _ from 'lodash';
import { Product } from "src/app/view-model/components/shopping-cart/product";
import { TagManagerPageViewEnum } from "./tag-manager.enum";

    export interface IEventGTM {        
        event:string;
        eventoInteractivoCategoria:string;
        eventoInteractivoAccion:string;
        eventoInteractivoEtiqueta:string;
        tipoPersona:string;  
        page:string;
        tipoFlujo: string;
     }

     export  class EventGTM implements IEventGTM{
         event= '';
         eventoInteractivoCategoria='';
         eventoInteractivoAccion= '';
         eventoInteractivoEtiqueta='';
         tipoPersona='';
         page='';
         tipoFlujo= "mdcp";
         step =0 ;       
         isPersonaNatural=true; 
         origen= "";
         constructor() {
             this.setEtiqueta = this.setEtiqueta.bind(this);
             this.getEtiqueta = this.getEtiqueta.bind(this);
             this.getCategoria = this.getCategoria.bind(this);
             this.getAccion = this.getAccion.bind(this);
             this.setAccion = this.setAccion.bind(this);
             this.accionClick = this.accionClick.bind(this);
             this.setStep = this.setStep.bind(this);
             this.setTipoPersona = this.setTipoPersona.bind(this);
             this.setIsPersonaNatural = this.setIsPersonaNatural.bind(this);
             
         }
   
         public setEtiqueta(etiqueta:string):EventGTM{
            this.eventoInteractivoEtiqueta=etiqueta;
            return this;
         }

         public getEtiqueta():string{
             return this.eventoInteractivoEtiqueta;  
         }
         public getCategoria():string{
              return this.eventoInteractivoCategoria;  
         }
        public getAccion():string{
            return this.eventoInteractivoAccion;  
        }

        public setAccion(accion:string):EventGTM{
            this.eventoInteractivoAccion=accion;
            return this;
        }

        public setTipoPersona(tipoPersona:string):EventGTM{
            this.tipoPersona=tipoPersona;
            return this;
        }

        public setIsPersonaNatural(isPersonaNatural:boolean):EventGTM{
            this.isPersonaNatural=isPersonaNatural;
            this.tipoPersona = isPersonaNatural?'persona':'empresa';
            return this;
        }

       public setStep(step:number):EventGTM{
            this.step=step;
            return this;
        }

        public accionClick():EventGTM{
            this.eventoInteractivoAccion='click';
            return this;
        }

        public etiquetaAcontinuar():EventGTM{
            this.eventoInteractivoEtiqueta ="continuar";
            return this;
        }  

        public setOrigen(origen:any):EventGTM{
            this.origen = origen;
            return this;
         }
         
         
     }

     export class EventEcommerceGTM extends EventGTM{
        ecommerce:{
                    transaction_id?:string;
                    affiliation?:string;
                    currency?:string;
                    value?:string;
                    payment_type?: string, 
                    tax?:string;
                    shipping?:string;
                    cupon?: string; 
                    items:any[];
                }

        constructor() {
            super();
            this.productToEcommerce = this.productToEcommerce.bind(this);
        }

       public productToEcommerce(product:Product):any{
            const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
            const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
            let price = 0;
            if (amount > 0) {
                price = amount / cantidad;
            }
            this.ecommerce = {
                items : [
                    { 
                      "item_list_name" : "",
                      "item_list_id" : "",
                      "item_name": product.title.toLowerCase(),
                      "item_id": product.codigoProducto.toLowerCase(),
                      "price": price,
                      "item_brand": "transbank",
                      "item_category": product.etiquetaVenta ? 'venta' : 'arriendo',
                      "item_variant": !product.tipoConexion ? 'default' : product.tipoConexion.toLowerCase(),
                      "quantity": cantidad
                    }]
            }

            return this.ecommerce ;
        }
     }
    

     export class InteraccionEventGTM extends EventGTM{
                price = '';
                cupon = '';
                getTag : () => any | undefined;
                
        constructor() {
            super();
            this.event= 'interacciones';
               this.categriaComoVender = this.categriaComoVender.bind(this);
               this.categriaDatosPersonales = this.categriaDatosPersonales.bind(this);
        }
        
        public categriaComoVender(tipoPersona:string):InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - como vender';
            this.tipoPersona=tipoPersona;
            this.eventoInteractivoEtiqueta=`como vender: ${this.tipoPersona}`;
            this.page = TagManagerPageViewEnum.COMO_QUIERES_VENDER;
            return this;
        }

        public categriaDatosPersonales():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - datos personales';
            this.eventoInteractivoAccion="click";
            this.eventoInteractivoEtiqueta="continuar"
            this.page = TagManagerPageViewEnum.DATOS_PERSONALES;
            return this;
        }

        public categoriaDatosDeComercio():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - datos de comercio';
            this.eventoInteractivoAccion="click";
            this.eventoInteractivoEtiqueta="continuar";
            this.page = TagManagerPageViewEnum.DATOS_COMERCIO;
            return this;
        }

        public categoriaConfiguracionDeProducto():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - configuracion producto';
            this.eventoInteractivoAccion="click";
            this.page = TagManagerPageViewEnum.CONF_DE_TU_PRODUCTO;
            return this;
        }

        public categoriaAdjuntarDocumentos():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - adjuntar documento';
            this.eventoInteractivoAccion="click";
            this.page = TagManagerPageViewEnum.ADJ_DOCUMENTOS;
            return this;
        }

        public categoriaCuentaBancaria():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - cuenta bancaria';
            this.eventoInteractivoAccion="click";
            this.page = TagManagerPageViewEnum.CTA_BCARIA_ABONO;
            return this;
        }

        public categoriaDetalleContratacion():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - detalle contratación';
            this.eventoInteractivoAccion="click";
            this.page = TagManagerPageViewEnum.DET_CONTRATACION_Y_CONFIRMA;
            return this;
        }
        public sinActividadEconomica():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - no inicio actividades';
            this.eventoInteractivoAccion="click";
            this.page = TagManagerPageViewEnum.NO_INICIO_ACTIVIDADES;
            return this;
        }
        public solicitudExitosaLlamar():InteraccionEventGTM{
            this.eventoInteractivoCategoria = 'marketplace - incorporación - no inicio actividades - solicitud exitosa';
            this.eventoInteractivoAccion="click";
            this.page = TagManagerPageViewEnum.SOLICITUD_EXITOSA;
            return this;
        }


        public categoriaResumenCompra(cupon: string,price: string): InteraccionEventGTM {
            this.eventoInteractivoCategoria = 'marketplace - resumen - compra';
            this.eventoInteractivoAccion = "click";
            this.eventoInteractivoEtiqueta = "Aplicar Cupon";
            this.cupon = cupon || '';
            this.price = price || '';
            this.page = TagManagerPageViewEnum.RESUMEN_COMPRA;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this;
            this.getTag = () => {
                return {
                    "event": that.event,
                    "evento-interactivo-categoria": that.eventoInteractivoCategoria.toLowerCase(),
                    "evento-interactivo-accion": that.eventoInteractivoAccion.toLowerCase(),
                    "evento-interactivo-etiqueta": that.eventoInteractivoEtiqueta.toLowerCase(),
                    "tipoPersona": that.tipoPersona.toLowerCase(),
                    "page": that.page,
                    "tipo-flujo": that.tipoFlujo,
                    "cupon": that.cupon,
                    "price": that.price
                };
            }
            return this;
        }
    }        


    export class ViewCartEventGTM extends EventEcommerceGTM {

        constructor() {
            super();
            this.eventoInteractivoAccion="view_cart";
            this.eventoInteractivoCategoria="ecommerce"
            this.event="view_cart";
            this.page = TagManagerPageViewEnum.COMO_QUIERES_VENDER;
        }     
            
    }

    export class BeginChekoutEventGTM extends EventEcommerceGTM {

        constructor() {
            super();
            this.eventoInteractivoAccion="begin_checkout";
            this.eventoInteractivoCategoria="ecommerce"
            this.event="begin_checkout";
            this.page = TagManagerPageViewEnum.DATOS_PERSONALES;
            this.step=2;
        }     
            
    }

    export class AddShippingInfoEventGTM extends EventEcommerceGTM {

        constructor() {
            super();
            this.eventoInteractivoAccion="add_shipping_info";
            this.eventoInteractivoCategoria="ecommerce"
            this.event="add_shipping_info";
            this.step=3;
            this.page=TagManagerPageViewEnum.DET_CONTRATACION_Y_CONFIRMA;
        }     
            
        public productToEcommerce(product:Product):any{
            const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
            const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
            let price = 0;
            if (amount > 0) {
                price = amount / cantidad;
            }
            this.ecommerce = {
                "currency":  "CLP",
                "payment_type": "unico",
                items : [
                    { 
                      "item_list_name" : "",
                      "item_list_id" : "",
                      "item_name": product.title.toLowerCase(),
                      "item_id": product.codigoProducto.toLowerCase(),
                      "price": price,
                      "item_brand": "transbank",
                      "item_category": product.etiquetaVenta ? 'venta' : 'arriendo',
                      "item_variant": !product.tipoConexion ? 'default' : product.tipoConexion.toLowerCase(),
                      "quantity": cantidad
                    }]
            }

            return this.ecommerce;
        }
    }

    export class AddToCartEventGTM extends EventEcommerceGTM {

        constructor() {
            super();
            this.eventoInteractivoAccion="add_to_cart";
            this.eventoInteractivoCategoria="ecommerce";
            this.event="add_to_cart";
            this.page="";
            this.tipoFlujo = "mdcp";
        }     
            
        public productToEcommerce(product:Product):any{

            const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
            const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
            let price = 0;
            if (amount > 0) {
                price = amount / cantidad;
            }
            this.eventoInteractivoEtiqueta = product.title.toLowerCase();
            this.ecommerce = {
                items : [
                    { 
                      "item_list_name" : "",
                      "item_list_id" : "",
                      "item_name": product.title.toLowerCase(),
                      "item_id": product.codigoProducto.toLowerCase(),
                      "price": price,
                      "item_brand": "transbank",
                      "item_category": product.etiquetaVenta ? 'venta' : 'arriendo',
                      "item_variant": !product.tipoConexion ? 'default' : product.tipoConexion.toLowerCase(),
                      "quantity": cantidad
                    }]
            }

            return this.ecommerce;
        }

        setOrigen(utm:string):AddToCartEventGTM{
            this.origen = utm;
            return this;
         }
    }


    export class PurchaseEventGTM extends EventEcommerceGTM {
        codigoPedido='';
        codigoDescuento?='';

        constructor() {
            super();
            this.eventoInteractivoAccion="purchase";
            this.eventoInteractivoCategoria="ecommerce"
            this.event="purchase";
            this.step=3;
            this.setCodigoPedido = this.setCodigoPedido.bind(this);
            this.page=TagManagerPageViewEnum.CONFIRMA_COMPRA;

        }     

       public  setCodigoPedido(codigoSeguimiento:string):EventEcommerceGTM{
            this.codigoPedido=codigoSeguimiento;
            return this;
        }
        public productToEcommerce(product:Product):any{
            const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
            const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
            //const totalCompra = Number(amount);
            let price = 0;
            if (amount > 0) {
                price = amount / cantidad;
            }
            this.ecommerce = {
                "transaction_id": this.codigoPedido,
                "affiliation": "MarketPlace",
                "value": amount,
                "tax": "0.00",
                "shipping": "",
                "currency": "CLP",
                "cupon": this.codigoDescuento,       
                items : [
                    { 
                      "item_list_name" : "",
                      "item_list_id" : "",
                      "item_name": product.title.toLowerCase(),
                      "item_id": product.codigoProducto.toLowerCase(),
                      "price": price,
                      "item_brand": "transbank",
                      "item_category": product.etiquetaVenta ? 'venta' : 'arriendo',
                      "item_variant": !product.tipoConexion ? 'default' : product.tipoConexion.toLowerCase(),
                      "quantity": cantidad
                    }]
            }

            return this.ecommerce;
        }
            
    }

    export class PageViewEventGTM extends EventGTM {

         constructor() {
            super();
            this.eventoInteractivoAccion="page-view";
            this.event="page-view";
         }     
            
        comoQuieresVender():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.COMO_QUIERES_VENDER;
            return this;
         }
         datosPersonales():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.DATOS_PERSONALES;
            return this;
         }
         datosComercio():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.DATOS_COMERCIO;
            return this;
         }         
         configuracionDeTuProducto():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.CONF_DE_TU_PRODUCTO;
            return this;
         }         
         adjDocumentos():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.ADJ_DOCUMENTOS;
            return this;
         }         
         ctaBancariaAbono():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.CTA_BCARIA_ABONO;
            return this;
         }         
         detallesContratacionConfirma():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.DET_CONTRATACION_Y_CONFIRMA;
            return this;
         }         
         confirmaCompra():PageViewEventGTM{
            this.page = TagManagerPageViewEnum.CONFIRMA_COMPRA;
            return this;
         }      
         sinActividadEconomica():PageViewEventGTM{
            this.page= (TagManagerPageViewEnum.NO_INICIO_ACTIVIDADES);       
            return this;
         }  
         solicitudExitosaLlamar():PageViewEventGTM{
            this.page= (TagManagerPageViewEnum.SOLICITUD_EXITOSA);       
            return this;
         }      

    }


    export class GoogleTagManager  {

     
        public static  eventInteracciones():InteraccionEventGTM{
            return new InteraccionEventGTM();
        }        
        public static eventBeginChekout():BeginChekoutEventGTM{
            return new BeginChekoutEventGTM();
        }
        public static eventViewCart():ViewCartEventGTM{
            return new ViewCartEventGTM();
        }
        
        public static eventAddShippingInfo():AddShippingInfoEventGTM{
            return new AddShippingInfoEventGTM();
        }
        public static eventPurchaseEventGTM():PurchaseEventGTM{
            return new PurchaseEventGTM();
        }

        public static eventAddToCart():AddToCartEventGTM{
            return new AddToCartEventGTM();
        }

        public static eventPageView():PageViewEventGTM{
            return new PageViewEventGTM();
        }
            
    }

             